import type { WorkflowSeitenConfig } from './MehrstufigerWorkflow';

export const EMAIL_WORKFLOWS: WorkflowSeitenConfig = {
  titel: 'E-Mail erstellen',
  untertitel: 'Mehrstufige KI-Workflows: von der Recherche über die Struktur bis zum fertigen Text.',
  icon: 'mail',
  startLabel: 'E-Mail erstellen',
  ergebnisTitel: 'Fertige E-Mail',
  varianten: [
    {
      id: 'newsletter',
      label: 'Newsletter',
      beschreibung: '3 Schritte · Recherche, Gliederung, Text',
      workflowName: 'Email: Newsletter-Erstellung (Komplett)',
      felder: [
        { name: 'industry', label: 'Branche', pflicht: true, platzhalter: 'z. B. IT-Sicherheit, SaaS' },
        { name: 'target_audience', label: 'Zielgruppe', pflicht: true, platzhalter: 'z. B. CISOs im Mittelstand' },
        { name: 'newsletter_theme', label: 'Thema', pflicht: true, platzhalter: 'z. B. NIS2 in drei Minuten' },
        { name: 'company_name', label: 'Firmenname', platzhalter: 'Ihr Firmenname' },
        { name: 'sender_name', label: 'Absender', platzhalter: 'Ihr Name' },
      ],
    },
    {
      id: 'promotional',
      label: 'Angebot',
      beschreibung: '2 Schritte · Angebot und Aufruf',
      workflowName: 'Email: Promotional Campaign',
      felder: [
        { name: 'product_name', label: 'Produkt oder Leistung', pflicht: true, platzhalter: 'z. B. Pentest-Paket' },
        { name: 'target_audience', label: 'Zielgruppe', pflicht: true, platzhalter: 'z. B. Bestandskunden' },
        { name: 'offer_details', label: 'Angebot', pflicht: true, mehrzeilig: true, platzhalter: 'z. B. 20 % Nachlass bis Monatsende' },
        { name: 'offer_duration', label: 'Laufzeit', platzhalter: 'z. B. bis 31. Oktober' },
        { name: 'company_name', label: 'Firmenname', platzhalter: 'Ihr Firmenname' },
      ],
    },
    {
      id: 'followup',
      label: 'Nachfassen',
      beschreibung: '2 Schritte · nach Termin oder Gespräch',
      workflowName: 'Email: Follow-up Sequence',
      felder: [
        { name: 'meeting_context', label: 'Anlass', pflicht: true, platzhalter: 'z. B. Erstgespräch, Demo' },
        { name: 'recipient_name', label: 'Empfänger', pflicht: true, platzhalter: 'Name' },
        { name: 'recipient_company', label: 'Firma des Empfängers', platzhalter: 'Firma' },
        { name: 'sender_name', label: 'Ihr Name', platzhalter: 'Ihr Name' },
        { name: 'company_name', label: 'Ihre Firma', platzhalter: 'Ihr Firmenname' },
        { name: 'attachments', label: 'Anlagen', platzhalter: 'z. B. Präsentation, Preisliste' },
        { name: 'discussion_points', label: 'Besprochen', pflicht: true, mehrzeilig: true, platzhalter: 'Was wurde besprochen?' },
        { name: 'next_steps', label: 'Nächste Schritte', mehrzeilig: true, zeilen: 2, platzhalter: 'Was ist vereinbart?' },
      ],
    },
  ],
};

export const BLOG_WORKFLOWS: WorkflowSeitenConfig = {
  titel: 'Blog erstellen',
  untertitel: 'Mehrstufige KI-Workflows für Anleitungen, Listen, Fallstudien und Branchenanalysen.',
  icon: 'book',
  startLabel: 'Blogartikel erstellen',
  ergebnisTitel: 'Fertiger Blogartikel',
  varianten: [
    {
      id: 'howto',
      label: 'Anleitung',
      beschreibung: '3 Schritte · Schritt-für-Schritt-Guide',
      workflowName: 'Blog: How-To Guide (Komplett)',
      felder: [
        { name: 'topic', label: 'Thema', pflicht: true, platzhalter: 'z. B. MFA im Unternehmen einführen' },
        { name: 'target_audience', label: 'Zielgruppe', pflicht: true, platzhalter: 'z. B. IT-Leitung ohne Security-Team' },
        { name: 'skill_level', label: 'Vorwissen', optionen: ['Anfänger', 'Fortgeschritten', 'Experte'] },
        { name: 'desired_outcome', label: 'Ziel für den Leser', mehrzeilig: true, zeilen: 2, platzhalter: 'Was kann der Leser danach?' },
      ],
    },
    {
      id: 'listicle',
      label: 'Liste',
      beschreibung: '2 Schritte · „Die 10 besten …“',
      workflowName: 'Blog: Listicle Post',
      felder: [
        { name: 'listicle_topic', label: 'Thema', pflicht: true, platzhalter: 'z. B. Häufige Fehler bei Backups' },
        { name: 'number_of_items', label: 'Anzahl Punkte', pflicht: true, standard: '10', platzhalter: '10' },
        { name: 'target_audience', label: 'Zielgruppe', pflicht: true, platzhalter: 'z. B. Geschäftsführung' },
      ],
    },
    {
      id: 'casestudy',
      label: 'Fallstudie',
      beschreibung: '2 Schritte · Problem, Lösung, Ergebnis',
      workflowName: 'Blog: Case Study',
      felder: [
        { name: 'client_name', label: 'Kunde oder Projekt', pflicht: true, platzhalter: 'z. B. Acme GmbH' },
        { name: 'industry', label: 'Branche', platzhalter: 'z. B. Maschinenbau' },
        { name: 'timeline', label: 'Zeitrahmen', platzhalter: 'z. B. 3 Monate' },
        { name: 'challenge', label: 'Herausforderung', pflicht: true, mehrzeilig: true, platzhalter: 'Was war das Problem?' },
        { name: 'solution', label: 'Lösung', pflicht: true, mehrzeilig: true, platzhalter: 'Wie wurde es gelöst?' },
        { name: 'results', label: 'Ergebnisse', mehrzeilig: true, zeilen: 2, platzhalter: 'Messbare Ergebnisse' },
      ],
    },
    {
      id: 'industry',
      label: 'Branchenanalyse',
      beschreibung: '2 Schritte · Trends und Einordnung',
      workflowName: 'Blog: Industry Analysis',
      felder: [
        { name: 'industry', label: 'Branche', pflicht: true, platzhalter: 'z. B. Gesundheitswesen' },
        { name: 'analysis_focus', label: 'Schwerpunkt', pflicht: true, platzhalter: 'z. B. Ransomware-Lage' },
        { name: 'time_period', label: 'Zeitraum', platzhalter: 'z. B. 2024–2026' },
      ],
    },
  ],
};
